<template>
    <div>
        <v-layout row wrap align-center justify-center>
            <v-flex xs12>

                <v-slide-y-transition>
                    <v-progress-linear
                            v-show="loading"
                            :indeterminate="true"
                            :height="2"
                    ></v-progress-linear>
                </v-slide-y-transition>

                <v-date-picker
                        dark
                        color="primary"
                        locale="es-es"
                        v-model="day"
                        :allowed-dates="allowedDates">
                </v-date-picker>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    export default{
        name: 'DayPicker',
        props: ['specialist', 'whenNoDatesAvailable', 'onDateSelect'],
        data(){
            return {
                day: '2019-03-15',
                dates: [],
                timeInterval: 60,
                loading: true
            }
        },
        mounted(){
            var vm = this
            if(!vm.specialist){
                vm.loading = false
                return
            }

            vm.getAvailableDates()

        },
        methods:{
            ...mapMutations(['showSnackBar', 'closeSnackBar']),
            allowedDates(day){
                var vm = this
                if(!vm.dates.length) return false

                let matchedDate = vm.dates.find(date => date.date === day) || null
                if(matchedDate){
                    if(!matchedDate.intervals.length) return false
                }

                const currentDates = vm.dates.map(date => date.date)
                return currentDates.indexOf(day) !== -1
            },
            async getAvailableDates(){

                var vm = this
                vm.loading = true

                if(!vm.specialist){
                    vm.showSnackBar('No se ha seleccionado especialista')
                    if(typeof vm.whenNoDatesAvailable == 'function'){
                        vm.whenNoDatesAvailable()
                    }
                    vm.loading = false
                    return
                }

                const res = await fetch('/we-help/api/available_dates.json?specialist=' + vm.specialist.id)
                vm.loading = false
                const json = await res.json()
                const dates = json.result.available_dates
                vm.dates = dates
                vm.timeInterval = json.result.time_interval

                if(dates.length == 0){
                    vm.showSnackBar('No hay horas disponibles para este especialista')
                    if(typeof vm.whenNoDatesAvailable == 'function'){
                        vm.whenNoDatesAvailable()
                    }
                }

                vm.day = dates[0].date
                vm.$nextTick(function(){
                    vm.setSelectedDay(dates[0].date)
                })

            },
            setSelectedDay(newDate){

                var vm = this
                const currentDates = vm.dates
                const matchedDate = Object.assign({}, currentDates.find(date => date.date === newDate))
                const dateDetail =  Object.keys(matchedDate).length ? (delete matchedDate.date && matchedDate) : null

                if(typeof vm.onDateSelect == 'function'){
                    vm.onDateSelect({
                        date: newDate,
                        timeInterval: vm.timeInterval,
                        details: dateDetail
                    })
                }
            }
        },
        watch:{
            specialist(val){
                this.getAvailableDates()
            },
            day(val){
                var vm = this
                vm.setSelectedDay(val)
            }
        }
    }
</script>

<style >
    .v-date-picker-table.v-date-picker-table--date .v-btn.v-btn--flat.v-btn--floating.v-btn--disabled{
        color: #df5c54 !important;
    }
</style>
